import { MdDelete } from "react-icons/md";
import { HiOutlineMinusSm, HiOutlinePlusSm } from "react-icons/hi";
import { useState, useEffect } from "react";
import { naira } from "../screens/stores/stockManagement/AddStockPage";

const ProductSelected = ({ product, removeProduct, updateCartTotal, sellingCart, currency }) => {
  const [unitPrice, setUnitPrice] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const [totalPrice, setTotalPrice] = useState(null);
  let imageUrl = `${product.productImage[0].split("/upload/")[0]}/upload/f_auto,q_auto,w_100/${product.productImage[0].split("/upload/")[1]}`;

  useEffect(() => {
    console.log(product, product.soldQuantity, "product");

    product.soldQuantity ? setQuantity(product.soldQuantity) : setQuantity(1);
    product.soldUnitPrice ? setUnitPrice(product.soldUnitPrice) : setUnitPrice(product.unitPrice);
    product.totalPrice ? setTotalPrice(product.totalPrice) : setTotalPrice(product.unitPrice * 1);
  }, []);

  /*  useEffect(() => {
    setUnitPrice(product.soldUnitPrice);
    setQuantity(product.soldQuantity);
  }, [sellingCart]); */

  /*   useEffect(() => {
    setTotalPrice(unitPrice * quantity);
  }, [unitPrice, quantity]); */

  /*   useEffect(() => {
    let newCart = [...sellingCart];
    let i = sellingCart.indexOf(product);
    let updatedProduct = { ...product, totalPrice: unitPrice * quantity, soldUnitPrice: unitPrice, soldQuantity: quantity };
    newCart[i] = updatedProduct;
    updateCartTotal(newCart);
  }, [totalPrice]); */

  /*  useEffect(()=>{
    parseInt(quantity)>parseInt(product.quantity) && setQuantity(product.quantity)
  },[quantity]) */

  /*   const controlQuantityInput = (e) => {
    console.log(parseInt(e.target.value) > product.quantity);
    if (parseInt(e.target.value) < 1) {
      e.target.value = 1;
      setQuantity(1);
    } else if (parseInt(e.target.value) > parseInt(product.quantity) - parseInt(product.damagedAmount)) {
      console.log("here is greated");
      e.target.value = parseInt(product.quantity) - parseInt(product.damagedAmount);
      setQuantity(e.target.value);
    } else {
      setQuantity(e.target.value);
    }
  }; */

  return (
    <>
      <div className='PS9onjjhhdgv'>
        <span style={{ cursor: "pointer" }} onClick={() => removeProduct(product)}>
          <MdDelete color='#E31E1E' size={26} />
        </span>
        <div className='EachProductSelected'>
          <img src={imageUrl} />
          <div>
            <p>{product.name}</p>
            <div className='unitPriceEditSell'>
              <span>Price</span>
              <div>
                <span>
                  {" "}
                  {currency} {unitPrice?.toLocaleString()}
                </span>
                {/* <input value={unitPrice} type={"number"} className='inputUnitPriceEdit' placeholder={product.unitPrice} /> */}
              </div>
            </div>
          </div>
          <div className='quantitySellP'>
            <p>Qty</p>
            <div>
              {/*  <span onClick={() => setQuantity(quantity - 1 < 1 ? 1 : quantity - 1)}>
                <HiOutlineMinusSm />
              </span> */}
              <span

              //onChange={(e) => controlQuantityInput(e)}
              >
                {quantity?.toLocaleString()}
              </span>
              {/*     <span>
                <HiOutlinePlusSm
                  onClick={() =>
                    setQuantity(
                      quantity >= parseInt(product.quantity) - parseInt(product.damagedAmount)
                        ? parseInt(product.quantity) - parseInt(product.damagedAmount)
                        : quantity + 1
                    )
                  }
                />
              </span> */}
            </div>
          </div>
          <div className='totalPriceSellProd'>
            <p>Total price</p>
            <p>
              {currency} {totalPrice?.toLocaleString()}
            </p>
          </div>
        </div>

        <div className='checkedCirle'>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default ProductSelected;
